// extracted by mini-css-extract-plugin
module.exports = {"line":"SkeletonLine_line__2k_bh","small":"SkeletonLine_small__1FGVD","big":"SkeletonLine_big__2OwR3"};